import React from 'react';

function DashboardCard({ title, subtitle, action, className = '', children }) {
  return (
    <section
      className={`bg-white rounded-xl border border-gray-200 shadow-sm p-5 ${className}`}
    >
      {(title || action) && (
        <div className="flex items-start justify-between gap-4 mb-4">
          <div>
            {title && (
              <h2 className="text-base font-semibold text-gray-900">{title}</h2>
            )}
            {subtitle && (
              <p className="text-xs text-gray-500 mt-1 leading-relaxed">
                {subtitle}
              </p>
            )}
          </div>
          {action}
        </div>
      )}
      {children}
    </section>
  );
}

export default DashboardCard;
